import React, { useMemo } from 'react';
import { format } from 'date-fns';

import { SoundBar } from '@components/SoundBar';
import { useAuth } from '@context/auth/base';
import type { FragmentType } from '@graphql/reactQuery';
import { CollectorFeaturedReleaseFragmentDoc, getFragment, gql } from '@graphql/reactQuery';

import { ProfileTopSectionSkeleton } from './ProfileTopSectionSkeleton';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment CollectorFeaturedRelease on CollectedRelease {
    id

    release {
      ...SoundBarRelease
    }
    firstNftOwned {
      id
      updatedAt
    }
  }
`);

export const FeaturedSound = ({
  featuredReleaseFrag,
  isLoading,
  userId,
}: {
  featuredReleaseFrag: FragmentType<CollectorFeaturedReleaseFragmentDoc>;
  isLoading: boolean;
  userId: string;
}) => {
  const { authUser } = useAuth();

  const featuredRelease = getFragment(CollectorFeaturedReleaseFragmentDoc, featuredReleaseFrag);

  const collectedTimeString = useMemo(() => {
    if (!featuredRelease?.firstNftOwned?.updatedAt) {
      return undefined;
    }
    return `Collected ${format(new Date(featuredRelease.firstNftOwned.updatedAt), 'MMM dd, yyyy')}`;
  }, [featuredRelease.firstNftOwned?.updatedAt]);

  const isOwner = authUser?.id === userId;

  return (
    <div className="mt-6 flex flex-col gap-2 bg-white px-5 md:mt-12 lt:px-0">
      <div className="font-title text-title-m font-medium md:text-title-l">Featured Sound</div>
      {isLoading ? (
        <ProfileTopSectionSkeleton />
      ) : (
        <SoundBar
          showEditFeaturedSoundDropdownMenuItem={isOwner}
          mintReferral={null}
          collectButtonSource="Featured Sound Sound Bar"
          releaseFrag={featuredRelease.release}
          customSubTitle={
            collectedTimeString ? (
              <p className="font-base text-base-s text-white opacity-60">{collectedTimeString}</p>
            ) : undefined
          }
        />
      )}
    </div>
  );
};
